// import { AppState } from '@/store/state';
// import { ToggleSidebarMenu } from '@/store/ui/actions';
// import { UiState } from '@/store/ui/state';
// import {
//   AfterViewInit,
//   Component,
//   HostBinding,
//   OnInit,
//   Renderer2
// } from '@angular/core';
// import { Store } from '@ngrx/store';
// import { Observable } from 'rxjs';

// @Component({
//   selector: 'app-main',
//   templateUrl: './main.component.html',
//   styleUrls: ['./main.component.scss']
// })
// export class MainComponent implements OnInit, AfterViewInit {
//   @HostBinding('class') class = 'wrapper';
//   public ui: Observable<UiState>;
//   public appLoaded: boolean = false;

//   constructor(
//     private renderer: Renderer2,
//     private store: Store<AppState>
//   ) { }

//   ngOnInit() {
//     this.ui = this.store.select('ui');
//     this.renderer.removeClass(
//       document.querySelector('app-root'),
//       'login-page'
//     );
//     this.renderer.removeClass(
//       document.querySelector('app-root'),
//       'register-page'
//     );
//     this.renderer.addClass(
//       document.querySelector('app-root'),
//       'layout-fixed'
//     );

//     this.ui.subscribe(
//       ({ menuSidebarCollapsed, controlSidebarCollapsed, darkMode }) => {
//         if (menuSidebarCollapsed) {
//           this.renderer.removeClass(
//             document.querySelector('app-root'),
//             'sidebar-open'
//           );
//           this.renderer.addClass(
//             document.querySelector('app-root'),
//             'sidebar-collapse'
//           );
//         } else {
//           this.renderer.removeClass(
//             document.querySelector('app-root'),
//             'sidebar-collapse'
//           );
//           this.renderer.addClass(
//             document.querySelector('app-root'),
//             'sidebar-open'
//           );
//         }

//         if (controlSidebarCollapsed) {
//           this.renderer.removeClass(
//             document.querySelector('app-root'),
//             'control-sidebar-slide-open'
//           );
//         } else {
//           this.renderer.addClass(
//             document.querySelector('app-root'),
//             'control-sidebar-slide-open'
//           );
//         }

//         if (darkMode) {
//           this.renderer.addClass(
//             document.querySelector('app-root'),
//             'dark-mode'
//           );
//         } else {
//           this.renderer.removeClass(
//             document.querySelector('app-root'),
//             'dark-mode'
//           );
//         }
//       }
//     );
//   }

//   onToggleMenuSidebar() {
//     this.store.dispatch(new ToggleSidebarMenu());
//   }

//   ngAfterViewInit() {
//     this.appLoaded = true;
//   }
// }


// Issue whenever the child UI load its change the state from False to True but Angular already detact the component so when the state change its raise error


import { AppState } from '@/store/state';
import { ToggleSidebarMenu } from '@/store/ui/actions';
import { UiState } from '@/store/ui/state';
import { AfterViewInit, Component, HostBinding, OnDestroy, OnInit, Renderer2, ChangeDetectorRef } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.scss']
})
export class MainComponent implements OnInit, AfterViewInit, OnDestroy {
  @HostBinding('class') class = 'wrapper';
  public ui?: Observable<UiState>;
  public appLoaded: boolean = false;
  private destroy$ = new Subject<void>();
  private appRoot!: HTMLElement | null;

  constructor(
    private renderer: Renderer2,
    private store: Store<AppState>,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit() {
    this.appRoot = document.querySelector('app-root');
    this.renderer.removeClass(this.appRoot, 'login-page');
    this.renderer.removeClass(this.appRoot, 'register-page');
    this.renderer.addClass(this.appRoot, 'layout-fixed');

    this.ui = this.store.select('ui');
    this.ui.pipe(takeUntil(this.destroy$)).subscribe(
      ({ menuSidebarCollapsed, controlSidebarCollapsed, darkMode }) => {
        if (menuSidebarCollapsed) {
          this.renderer.addClass(this.appRoot, 'sidebar-collapse');
          this.renderer.removeClass(this.appRoot, 'sidebar-open');
        } else {
          this.renderer.removeClass(this.appRoot, 'sidebar-collapse');
          this.renderer.addClass(this.appRoot, 'sidebar-open');
        }

        if (controlSidebarCollapsed) {
          this.renderer.removeClass(this.appRoot, 'control-sidebar-slide-open');
        } else {
          this.renderer.addClass(this.appRoot, 'control-sidebar-slide-open');
        }

        if (darkMode) {
          this.renderer.addClass(this.appRoot, 'dark-mode');
        } else {
          this.renderer.removeClass(this.appRoot, 'dark-mode');
        }
      }
    );
  }

  ngAfterViewInit() {
    this.appLoaded = true;
    this.cdr.detectChanges();
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  onToggleMenuSidebar() {
    this.store.dispatch(new ToggleSidebarMenu());
  }
}
